/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "History",
  size: 20
}

const SvgHistory = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M1 2h1v4h4v1H1V2" />
    <path
      fill="none"
      strokeWidth={1.1}
      d="M2.1 6.548C3.391 3.29 6.746 1 10.5 1c5 0 9 4 9 9s-4 9-9 9-9-4-9-9"
    />
    <path d="M9 4h1v7H9z" />
    <path fill="none" strokeWidth={1.1} d="M13.018 14.197l-3.573-3.572" />
  </Svg>
)

SvgHistory.defaultProps = defaultProps
export default SvgHistory
